import axios from 'axios'
import { localStorageAllStrings } from '../constants/defaultValues'

function apiInfo(host) {
  switch (host) {
    case 'test':
      return 'https://localhost:44329/api'
    case 'development':
      return 'https://crm-api-dev.mycon.com.br/api'
    case 'production':
      return 'https://crm-api.mycon.com.br/api'
    case 'myhost':
      return 'http://localhost/consorcio.digital/api'
    default:
      return 'https://localhost:44329/api'
  }
}

const host = window.location.href.includes('dashboard-dev')
  ? 'development'
  : // eslint-disable-next-line no-undef
    process.env.NODE_ENV || 'production'

const apiConnect = apiInfo(host)

export const baseUrl = axios.create({
  baseURL: `${apiConnect}/vendas`
})

try {
  const tokenStorage = localStorage.getItem(localStorageAllStrings.tokenStorage)
  if (tokenStorage) {
    baseUrl.defaults.headers.Authorization = `Bearer ${tokenStorage}`
  }
} catch (error) {
  console.error('Error accessing localStorage:', error)
}

baseUrl.interceptors.request.use(
  (config) => {
    try {
      const tokenStorage = localStorage.getItem(
        localStorageAllStrings.tokenStorage
      )
      if (tokenStorage) {
        config.headers = config.headers || {}
        config.headers.Authorization = `Bearer ${tokenStorage}`
      }
    } catch (error) {
      console.error('Error accessing localStorage:', error)
    }
    return config
  },
  (error) => Promise.reject(error)
)

baseUrl.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status
    if (status === 401) {
      localStorage.removeItem(localStorageAllStrings.tokenStorage)
      localStorage.removeItem(localStorageAllStrings.userStorage)
      delete baseUrl.defaults.headers.Authorization
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export const baseCepUrl = axios.create({
  baseURL: apiConnect
})
